export const ActionProp = Object.freeze({
    ExternalUrl: 'externalUrl',
    ActionType: 'actionType',
    BackEndUrl: 'backEndUrl',
    AddFilesToPost: 'addFilesToPost',
    MakeBackEndCallOnlyIfDataIsValid: 'makeBackEndCallOnlyIfDataIsValid',
    CollectGridFilterData: 'collectGridFilterData',
    FileNameOnDownload: 'fileNameOnDownload',
    FrontEndRouteName: 'frontEndRouteName',
    FrontEndRouteParams: 'frontEndRouteParams',
    AddPreserveFilterParam: 'addPreserveFilterParam',
    ModalFormComponentName: 'modalFormComponentName',
    CollectDataFromComponentName: 'collectDataFromComponentName'
});
